export { default } from './NFTHeading';
